"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPortal = require("react-portal");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _emotionTheming = require("emotion-theming");

var PopupPortal = function PopupPortal(_ref) {
  var popupNode = _ref.popupNode,
      content = _ref.content,
      close = _ref.close;
  return _react.default.createElement(_reactPortal.Portal, {
    node: popupNode
  }, (0, _isFunction.default)(content) ? content(close) : content);
};

PopupPortal.propTypes = {
  popupNode: _propTypes.default.instanceOf(HTMLElement).isRequired,
  content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  close: _propTypes.default.func.isRequired
};

var _default = (0, _emotionTheming.withTheme)(PopupPortal);

exports.default = _default;